import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FocusableOption, FocusOrigin, Highlightable } from '@angular/cdk/a11y';
import { FilterHierarchySelectOption } from '@nimbus-library/features/shared/components/nimbus-grid-filter/domain/filter-hirerarchy-select.model';

@Component({
  standalone: false,
  selector: 'nimbus-filter-hierarchy-select-list-item',
  templateUrl: './nimbus-filter-hierarchy-select-list-item.component.html',
  styleUrls: ['./nimbus-filter-hierarchy-select-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusFilterHierarchySelectListItemComponent implements FocusableOption, Highlightable {
  @Input() public option: FilterHierarchySelectOption;
  @Input() public selected: boolean;
  @Input() public set withIndent(val: boolean) {
    this.indent = val ? 19 : 0;
  }
  @Output()
  public filterSelect: EventEmitter<{ selected: boolean; option: FilterHierarchySelectOption; withChildren: boolean }> = new EventEmitter();
  @ViewChild('filterItem', { static: true }) public item: ElementRef<HTMLButtonElement>;
  public indent: number = 0;
  private readonly activeClass = 'nimbus-select-filter-item-focus';
  private readonly clickedClass = 'nimbus-select-filter-item-active';
  public constructor(private readonly renderer: Renderer2) {}

  public focus(origin?: FocusOrigin): void {
    this.item.nativeElement.focus();
  }

  public setActiveStyles(): void {
    this.renderer.addClass(this.item.nativeElement, this.activeClass);
  }

  public setInactiveStyles(): void {
    this.renderer.removeClass(this.item.nativeElement, this.activeClass);
  }

  public setClickStyle(): void {
    this.renderer.addClass(this.item.nativeElement, this.clickedClass);
  }

  public onClick(ev: MouseEvent | KeyboardEvent): void {
    this.filterSelect.emit({ selected: !this.selected, option: this.option, withChildren: !ev.ctrlKey });
  }

  public getLabel?(): string {
    return this.option.name;
  }
}
